<template>
  <div id="enterprise-layout">
    <a-layout>
      <a-layout-header class="header">
        <a-row style="flex-wrap: nowrap">
          <a-col
            flex="250px"
            style="display: flex; justify-content: center; align-items: center"
          >
            <div class="title-bar">
              <router-link to="/enterprise/enterpriseHome">
                <img class="logo" src="@/assets/logo.png" alt="logo" />
                <div class="title">企业用户中心</div>
              </router-link>
            </div>
          </a-col>
          <a-col
            flex="auto"
            style="display: flex; justify-content: center; align-items: center"
          >
            <a-menu
              v-model:selectedKeys="current"
              mode="horizontal"
              :items="items"
              @click="doMenuClick"
            />
          </a-col>
          <a-col
            flex="250px"
            style="display: flex; justify-content: right; align-items: center"
          >
            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link">
                <a-avatar :size="48">
                  <template #icon><UserOutlined /></template>
                </a-avatar>
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-divider />
                  <a-menu-item
                    key="1"
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <router-link to="/user-login" @click="userLogout">
                      <LogoutOutlined /> 退出登录</router-link
                    >
                  </a-menu-item>
                  <a-menu-divider />
                  <a-menu-item
                    key="2"
                    disabled
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <router-link to="/user-login">
                      <MailOutlined /> 消息中心</router-link
                    >
                  </a-menu-item>
                  <a-menu-divider />
                  <a-menu-item
                    key="3"
                    disabled
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <router-link to="/user-login">
                      <UserDeleteOutlined /> 用户注销</router-link
                    >
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </a-col>
        </a-row>
      </a-layout-header>
      <a-layout-content class="content">
        <router-view />
      </a-layout-content>
    </a-layout>
  </div>
</template>
<script setup lang="ts">
import { useRouter, useRoute } from "vue-router";
import { h, ref, watch } from "vue";
import {
  AppstoreOutlined,
  UserOutlined,
  LogoutOutlined,
  UserDeleteOutlined,
  MailOutlined,
} from "@ant-design/icons-vue";
import { MenuProps, message } from "ant-design-vue";
import { enterprisesLogout } from "@/api/enterprise";
// 导航链接
// 实例
const router = useRouter();
const route = useRoute();
const current = ref<string[]>(["/user/userHome"]);

//点击菜单跳转
const doMenuClick = ({ key }: { key: string }) => {
  router.push({
    path: key,
  });
};

//刷新时高亮问题
watch(
  () => route.path,
  (newPath) => {
    // 将当前路径赋值给 current
    current.value = [newPath];
  },
  { immediate: true } // 关键配置：初始化时立即执行一次，解决刷新不高亮的问题
);

const items = ref<MenuProps["items"]>([
  {
    key: "/enterprise/enterpriseHome",
    icon: () => h(UserOutlined),
    label: "企业主页",
    title: "企业主页",
  },
  {
    key: "/enterprise/enterpriseProject",
    icon: () => h(AppstoreOutlined),
    label: "项目管理",
    title: "项目管理",
  },
]);

const userLogout = async () => {
  const res = await enterprisesLogout(null);
  if (res && res.data) {
    message.success("登出成功!");
    router.push({
      path: "/enterprise-login",
      replace: true,
    });
    return null;
  }
  message.error("登出异常！");
};
</script>

<style scoped>
#user-layout .header {
  height: 65px;
}

#user-layout .content {
  margin-bottom: 0px;
  background: linear-gradient(to right, #fff, #bcb9b9);
}

.header {
  background: #fff;
  height: 60px;
}
.title-bar {
  display: flex;
  align-items: center;
}

.title-bar a {
  text-decoration: none;
  display: flex;
  align-items: center;
  color: inherit;
}
.title {
  color: #262626;
  font-size: 24px;
  font-weight: 600;
  margin-left: 16px;
  font-family: "Microsoft YaHei", "PingFang SC", "Hiragino Sans GB", "Heiti SC",
    "WenQuanYi Micro Hei", sans-serif;
  letter-spacing: 1px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.title:hover {
  color: #1890ff;
  text-shadow: 0 2px 4px rgba(24, 144, 255, 0.3);
}
.logo {
  height: 48px;
}
</style>
